const initialState = {
    isModalOpenAddTask: false,
    successAddTask: false,
    refreshTablet: false,
};

const timeSheetReducer = (state = initialState, action: { type: string; payload?: any }) => {
    switch (action.type) {
        case 'OPEN_MODAL_ADD_TASK':
            return { ...state, isModalOpenAddTask: true };
        case 'CLOSE_MODAL_ADD_TASK':
            return { ...state, isModalOpenAddTask: false };
        case 'SUCCESS_ADD_TASK':
            return { ...state, successAddTask: true };
        case 'RESET_SUCCESS_ADD_TASK':
            return { ...state, successAddTask: false };
        case 'REFRESH_TABLE_TIMESHEET_TOGGLE':
            return { ...state, refreshTablet: action.payload };
        default:
            return state;
    }
};

export default timeSheetReducer;